'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const accordions = Array.from(document.querySelectorAll('[data-gs1-accordion]'));
if (accordions) {
    accordions.forEach((accordion) => {
        const accordionItems = Array.from(accordion.children).filter((element) => element.classList.contains('accordion__item'));
        accordionItems.forEach((item) => {
            const accentColor = item.querySelector('[data-gs1-accordion-accentcolor]').getAttribute('data-gs1-accordion-accentcolor');
            if (accentColor !== undefined && accentColor !== '0') {
                item.style.borderLeftColor = accentColor;
            }
            const button = item.querySelector('.accordion__button');
            const icon = item.querySelector('.accordion__button-icon');
            if (button instanceof HTMLElement || icon instanceof HTMLElement) {
                const openItem = () => {
                    button.setAttribute('aria-expanded', 'true');
                    icon.setAttribute('aria-expanded', 'true');
                    item.querySelector('.accordion__collapse').setAttribute('data-gs1-accordion-collapsed', 'false');
                    item.querySelector('.accordion__item-header').classList.add('accordion__item-header--open');
                };
                const closeItem = () => {
                    button.setAttribute('aria-expanded', 'false');
                    icon.setAttribute('aria-expanded', 'false');
                    item.querySelector('.accordion__collapse').setAttribute('data-gs1-accordion-collapsed', 'true');
                    item.querySelector('.accordion__item-header').classList.remove('accordion__item-header--open');
                };
                const isOpen = () => button.getAttribute('aria-expanded') === 'true';
                // Toggle the accordion item if title is clicked
                button.addEventListener("click", (event) => {
                    event.preventDefault();
                    const wasOpen = isOpen();
                    if (!wasOpen) {
                        openItem();
                    }
                    else {
                        closeItem();
                    }
                    trackAccordionEvent(item);
                    event.stopImmediatePropagation();
                });
                icon.addEventListener("click", (event) => {
                    event.preventDefault();
                    const wasOpen = isOpen();
                    if (!wasOpen) {
                        openItem();
                    }
                    else {
                        closeItem();
                    }
                    trackAccordionEvent(item);
                    event.stopImmediatePropagation();
                });
                // Add Keyboard navigation for accordion.
                button.addEventListener('keydown', (event) => {
                    if (event.key === "ArrowDown" && !isOpen()) {
                        event.preventDefault();
                        const wasOpen = isOpen();
                        if (!wasOpen) {
                            openItem();
                        }
                        else {
                            closeItem();
                        }
                        trackAccordionEvent(item);
                        event.stopImmediatePropagation();
                    }
                    else if (event.key === "ArrowUp" && isOpen()) {
                        event.preventDefault();
                        trackAccordionEvent(item);
                        event.stopImmediatePropagation();
                    }
                });
            }
        });
        // Inside Element gs1_accordion it's possible to activate click-tracking measures. We'll add that functionality in here.
        const accordionClickTrackingStatus = accordion.getAttribute('data-gs1-accordion-click-tracking');
        const accordionClickTrackingTitle = accordion.querySelector('[data-gs1-accordion-click-tracker-title]');
        const accordionClickTrackingContent = accordion.querySelector('[data-gs1-accordion-click-tracker-content]');
        if (accordionClickTrackingStatus === '1') {
            accordionClickTrackingTitle.setAttribute('data-gs1-accordion-click-tracker-title', 'active');
            accordionClickTrackingContent.setAttribute('data-gs1-accordion-click-tracker-content', 'active');
            let accordionClickTrackerTitleActive = accordionClickTrackingTitle.getAttribute('data-gs1-accordion-click-tracker-title');
            let accordionClickTrackerContentActive = accordionClickTrackingContent.getAttribute('data-gs1-accordion-click-tracker-content');
            if (accordionClickTrackerTitleActive === 'active' && accordionClickTrackerContentActive === "active") {
                accordion.addEventListener("click", (event) => {
                    const el = event.target;
                    (el.getAttribute('data-gs1-accordion-title')) ?
                        el.setAttribute('data-track-action', 'open') : el.setAttribute('data-track-action', 'close');
                    (el.getAttribute('data-gs1-accordion-content')) ?
                        el.setAttribute('data-track-action', 'open') : el.setAttribute('data-track-action', 'close');
                });
            }
        }
    });
}
function trackAccordionEvent(element) {
    if (element) {
        let collapseElement = element.querySelector('.accordion__collapse');
        if (collapseElement) {
            let data = {
                event: 'event',
                eventCategory: 'Akkordeon',
                eventLabel: '',
                eventAction: 'open'
            };
            let headingElement = element.querySelector('.panel-heading');
            if (headingElement) {
                // This is needed for gs1_base/Packages/Mask/Resources/Private/Templates/Frontend/etracker-accordion-item.html
                if (headingElement.getAttribute('trigger-gtm-event-label')) {
                    data.eventLabel = headingElement.getAttribute('trigger-gtm-event-label');
                }
            }
            let buttonElement = element.querySelector('.accordion__button');
            if (data.eventLabel === '' && buttonElement) {
                data.eventLabel = buttonElement.innerText;
            }
            if (collapseElement.getAttribute('data-gs1-accordion-collapsed') === 'true') {
                data.eventAction = 'close';
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(data);
        }
    }
}
exports.default = {};
